import { useState } from 'react';

import Cookies from 'js-cookie';

type Props = {
  messageId: string;
};

export function useMessageVisibility({ messageId }: Props) {
  const hiddenMessages = Cookies.get('hiddenMessages')?.split(',') || [];
  const isVisibleByDefault = !hiddenMessages.includes(messageId);

  const [isVisible, setIsVisible] = useState(isVisibleByDefault);

  const handleCloseMessage = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    const updatedHiddenMessages = [...hiddenMessages, messageId];
    Cookies.set('hiddenMessages', updatedHiddenMessages.join(','));
    setIsVisible(false);
  };

  return { isVisible, handleCloseMessage };
}
